/*
 * Interface strings, Portuguese.
 *
 * The "ui" bucket: everything outside the calculators. Every language the
 * picker offers has a full file here, so no English leaks into a translated
 * interface. Calculator text lives in i18n/calc, which is English and Spanish
 * only. Legal and disclaimer text is in neither: it stays English everywhere,
 * with legal.englishGoverning beside it.
 *
 * Plural keys end _one/_other and are chosen by Intl.PluralRules for this
 * language; Chinese, Thai, Vietnamese and Indonesian have one form, so they
 * carry only _other and every count lands there.
 */

/* NOT REVIEWED BY A NATIVE SPEAKER. */

const strings = {
  "landing.lead": "Entre com sua conta AquaNetica para continuar.",
  "landing.signIn": "Entrar",
  "landing.signUpFree": "O cadastro é gratuito.",
  "common.close": "Fechar",
  "common.cancel": "Cancelar",
  "profile.title": "Perfil do sistema · {name}",
  "profile.subtitle": "A Gia usa isto para calibrar cada resposta deste projeto. Deixe em branco os campos que não se aplicam.",
  "profile.species": "Espécie",
  "profile.speciesPlaceholder": "ex.: salmão do Atlântico",
  "profile.systemType": "Tipo de sistema",
  "profile.select": "Selecione…",
  "profile.sys.ras": "RAS (recirculação)",
  "profile.sys.flow": "Fluxo aberto",
  "profile.sys.pond": "Viveiro",
  "profile.sys.cage": "Tanque-rede",
  "profile.sys.hatchery": "Larvicultura",
  "profile.sys.other": "Outro",
  "profile.volume": "Volume total (L)",
  "profile.temp": "Temperatura alvo (°C)",
  "profile.lifeStage": "Fase de vida",
  "profile.lifeStagePlaceholder": "smolt, juvenil, reprodutores",
  "profile.location": "Localização",
  "profile.locationPlaceholder": "ex.: Santa Catarina, BR",
  "profile.notes": "Observações adicionais",
  "profile.notesPlaceholder": "Qualquer outra informação que a Gia deva saber sobre este sistema",
  "profile.save": "Salvar perfil",
  "help.title": "Sobre e aviso legal",
  "help.about": "A Gia é uma assistente de IA para operadores de aquicultura, com calculadoras de engenharia integradas. Ela responde com base em material de referência e conhecimento geral para ajudar você a pensar sistemas, qualidade da água e equipamentos.",
  "legal.englishGoverning": "Os termos e o aviso legal são fornecidos em inglês. A versão em inglês é a que prevalece.",
  "feature.notNow": "Agora não",
  "feature.seePlans": "Ver planos",
  "lang.title": "Idioma",
  "lang.sub": "Define a interface e o idioma em que a Gia responde, não importa em qual idioma você escreva.",
  "lang.auto": "Automático (conforme meu navegador e minha pergunta)",
  "pe.timeline.ASAP": "O quanto antes",
  "pe.timeline.1–3 months": "1–3 meses",
  "pe.timeline.Just researching": "Só pesquisando",
  "pe.condition.New": "Novo",
  "pe.condition.Used": "Usado",
  "pe.condition.Either": "Tanto faz",
  "pe.missing.quantity": "quantas unidades você precisa",
  "pe.missing.city": "para onde vai",
  "pe.missing.date": "quando você precisa",
  "pe.nudge": "Os fornecedores geralmente não conseguem cotar sem saber {list}. Você pode enviar assim mesmo.",
  "pe.err.name": "Informe seu nome para sabermos a quem responder.",
  "pe.err.email": "Informe seu e-mail para podermos responder.",
  "pe.err.emailInvalid": "Esse e-mail não parece certo; confira, por favor.",
  "pe.err.quantity": "Informe quantas unidades você precisa.",
  "pe.err.city": "Informe a cidade de entrega.",
  "pe.err.send": "Não foi possível enviar sua solicitação. Tente novamente.",
  "pe.err.network": "Não foi possível conectar ao servidor. Verifique sua conexão e tente novamente.",
  "pe.title": "Me ajudem a conseguir isto",
  "pe.thanks": "Obrigado. Entraremos em contato pelo {email}.",
  "pe.done": "Pronto",
  "pe.whatYouNeed": "O que você precisa",
  "pe.equipment": "Equipamento",
  "pe.suggestedModels": "Modelos sugeridos:",
  "pe.hideDetails": "Ocultar detalhes",
  "pe.editDetails": "Editar detalhes",
  "pe.item": "Item que você precisa",
  "pe.specs": "Detalhes e dimensionamento",
  "pe.name": "Seu nome",
  "pe.email": "E-mail (para respondermos)",
  "pe.when": "Quando você precisa?",
  "pe.quantity": "Quantas unidades você precisa?",
  "pe.quantityPlaceholder": "ex.: 2 unidades",
  "pe.city": "Cidade de entrega",
  "pe.cityPlaceholder": "Para onde deve ser entregue?",
  "pe.neededBy": "Prazo (opcional)",
  "pe.condition": "Novo ou usado? (opcional)",
  "pe.budget": "Orçamento aproximado (opcional)",
  "pe.amount": "Valor",
  "pe.budgetAmount": "Valor do orçamento",
  "pe.budgetCurrency": "Moeda do orçamento",
  "pe.notSure": "Não sei",
  "pe.note": "Mais alguma coisa? (opcional)",
  "pe.notePlaceholder": "Qualquer outra informação que ajude a encontrar o item certo.",
  "pe.hideFarm": "Ocultar dados da fazenda",
  "pe.addFarm": "Adicionar dados da fazenda (opcional)",
  "pe.farm": "Nome da fazenda ou empresa",
  "pe.country": "País",
  "pe.sending": "Enviando…",
  "pe.send": "Enviar solicitação",
  "pe.reassurance": "Sem compromisso. Uma pessoa da AquaNetica responderá por e-mail.",
  "toolbar.answerLanguage": "Idioma: {name}",
  "toolbar.answerLanguageTitle": "Idioma",
  "project.namePrompt": "Nome do projeto?",
  "project.renamePrompt": "Renomear projeto:",
  "project.deleteWithChats": "Excluir o projeto \"{name}\" e seu chat?",
  "project.deleteWithChats_one": "Excluir o projeto \"{name}\" e seu chat?",
  "project.deleteWithChats_other": "Excluir o projeto \"{name}\" e seus {count} chats?",
  "project.delete": "Excluir o projeto \"{name}\"?",
  "file.proTitle": "Mensagens com arquivo são um recurso Pro",
  "file.proMessage": "Seu plano não inclui mensagens com arquivo. Mude para o Pro para anexar fichas técnicas, desenhos e fotos para a Gia ler. Mensagem com arquivo é qualquer mensagem enviada com um arquivo anexado.",
  "file.badType": "Anexe uma imagem (JPG, PNG, GIF, WEBP), um PDF, um arquivo do Word, Excel ou PowerPoint (.docx, .xlsx, .pptx) ou um arquivo de texto ou código (.txt, .md, .csv, .json, .r, .py).",
  "file.tooLarge": "O arquivo é muito grande. Os anexos devem ter menos de 20 MB.",
  "file.unreadable": "A Gia não conseguiu ler esse arquivo. Se ele tiver senha ou for um .doc, .xls ou .ppt antigo, salve-o como .docx, .xlsx ou .pptx sem senha e anexe de novo.",
  "file.noText": "Esse arquivo não tem texto que a Gia consiga ler. Se for uma digitalização ou quase só imagens, anexe-o como PDF ou imagem.",
  "file.tooBig": "Esse arquivo é grande demais para a Gia ler de uma vez. Divida-o em arquivos menores ou anexe só a parte de que precisa.",
  "file.notText": "Esse arquivo não é texto simples, embora o nome indique que sim. Salve-o como texto (UTF-8) e anexe de novo.",
  "chat.errSomething": "Desculpe, algo deu errado: {detail}",
  "chat.errNoBackend": "Desculpe, não consegui acessar a base de conhecimento. Verifique se o backend está rodando na porta 3001.",
  "file.attached": "· anexado a este chat",
  "file.left": "{count} mensagem com arquivo restante este mês",
  "file.left_one": "{count} mensagem com arquivo restante este mês",
  "file.left_other": "{count} mensagens com arquivo restantes este mês",
  "file.detachTitle": "Remover o arquivo: deixa de contar nas suas mensagens com arquivo",
  "file.detachLabel": "Remover arquivo",
  "file.detach": "Remover",
  "file.explain": "Cada mensagem enviada com este arquivo anexado conta como uma mensagem com arquivo. Remova quando a Gia não precisar mais consultá-lo.",
  "file.reattachHint": "{name}: anexe de novo para continuar perguntando sobre ele",
  "file.reattachTitle": "Anexar o arquivo de novo",
  "file.reattach": "Anexar de novo",
  "usage.questions": "{left} de {limit} pergunta restante este mês",
  "usage.questions_one": "{left} de {limit} pergunta restante este mês",
  "usage.questions_other": "{left} de {limit} perguntas restantes este mês",
  "usage.questionsShort": "{left}/{limit} pergunta restante",
  "usage.questionsShort_one": "{left}/{limit} pergunta restante",
  "usage.questionsShort_other": "{left}/{limit} perguntas restantes",
  "usage.files": "{left} de {limit} mensagem com arquivo",
  "usage.files_one": "{left} de {limit} mensagem com arquivo",
  "usage.files_other": "{left} de {limit} mensagens com arquivo",
  "usage.leftShort": "Resta {left} pergunta",
  "usage.leftShort_one": "Resta {left} pergunta",
  "usage.leftShort_other": "Restam {left} perguntas",
  "usage.remaining": "{left} / {limit} pergunta restante",
  "usage.remaining_one": "{left} / {limit} pergunta restante",
  "usage.remaining_other": "{left} / {limit} perguntas restantes",
  "usage.upgrade": "Melhorar plano",
  "wall.daily": "Você atingiu o limite de mensagens de hoje",
  "wall.feature": "O plano {plan} não inclui isto",
  "wall.featureYour": "Seu plano não inclui isto",
  "wall.files": "Você usou todas as {limit} mensagens com arquivo do seu plano {plan} este mês",
  "wall.questions": "Você usou todas as {limit} perguntas do seu plano {plan} este mês",
  "wall.generic": "Você atingiu um limite do seu plano",
  "wall.region": "Limite de perguntas atingido",
  "wall.refresh": "Suas perguntas do plano {plan} são renovadas no dia 1º.",
  "wall.refreshNoPlan": "Suas perguntas são renovadas no dia 1º.",
  "wall.stayFree": "As calculadoras continuam gratuitas e ilimitadas, e todos os seus chats anteriores continuam aqui para consulta.",
  "wall.upgrade": "Mude de plano em aquanetica.com",
  "sidebar.hide": "Ocultar barra lateral",
  "sidebar.search": "Buscar chats…",
  "sidebar.newChat": "+ Novo chat",
  "sidebar.newProject": "+ Projeto",
  "sidebar.tools": "🛠️ Ferramentas",
  "sidebar.backToGia": "Voltar para a Gia",
  "sidebar.calculator": "Calculadora",
  "sidebar.empty": "Ainda não há chats. Pergunte algo à Gia para começar.",
  "sidebar.profileSet": "Perfil do sistema definido",
  "sidebar.newInProject": "Novo chat neste projeto",
  "sidebar.editProfile": "Editar perfil",
  "sidebar.rename": "Renomear",
  "sidebar.delete": "Excluir",
  "sidebar.projectEmpty": "Ainda não há chats",
  "sidebar.noMatches": "Nenhum resultado para \"{q}\"",
  "sidebar.signedIn": "Conectado",
  "sidebar.signOut": "Sair",
  "sidebar.signingOut": "A terminar sessão…",
  "signout.title": "Terminar sessão",
  "signout.body": "A sua sessão no AquaNetica IQ e em aquanetica.com será terminada. Os documentos carregados e as avaliações de respostas são sempre removidos deste dispositivo. Tudo o resto que guardou fica aqui para quando voltar a entrar.",
  "signout.alsoClear": "Apagar também o meu trabalho guardado neste dispositivo: conversas, projetos e cálculos",
  "signout.irreversible": "Esta eliminação adicional é permanente. Esse trabalho é guardado apenas neste navegador, por isso não há cópia para restaurar.",
  "signout.confirm": "Terminar sessão",
  "sidebar.communityTitle": "Voltar para a comunidade AquaNetica (abre em uma nova aba)",
  "sidebar.community": "Voltar para a AquaNetica",
  "sidebar.help": "Ajuda e aviso legal",
  "drop.label": "Solte o arquivo para anexar",
  "toolbar.showSidebar": "Mostrar barra lateral",
  "toolbar.toggleSidebar": "Mostrar ou ocultar a barra lateral",
  "toolbar.newChat": "Novo chat",
  "toolbar.inProject": "No projeto:",
  "toolbar.home": "Voltar para a comunidade AquaNetica",
  "toolbar.homeTitle": "Voltar para a AquaNetica (abre em uma nova aba)",
  "toolbar.calc": "Abrir calculadora",
  "toolbar.theme": "Alternar tema",
  "hero.title": "Como posso ajudar?",
  "hero.calibrated": "A Gia está calibrada pelo perfil do sistema deste projeto.",
  "hero.noProfile": "Ainda não há perfil do sistema. Clique em ⚙ no projeto para criar um.",
  "hero.subtitle": "Pergunte qualquer coisa sobre sistemas de aquicultura, qualidade da água ou equipamentos.",
  "composer.attachTitle": "Anexar imagem ou PDF",
  "composer.attachLabel": "Anexar arquivo",
  "composer.send": "Enviar",
  "answer.copyTitle": "Copiar resposta",
  "answer.copied": "Copiado",
  "answer.copy": "Copiar",
  "answer.retryTitle": "Fazer esta pergunta de novo",
  "answer.retryLabel": "Tentar a resposta de novo",
  "answer.retry": "Tentar de novo",
  "answer.good": "Boa resposta",
  "answer.bad": "Resposta ruim",
  "answer.sourcing": "Precisa de ajuda para conseguir isto? →",
  "answer.searching": "Buscando na biblioteca de documentos…",
  "answer.scrollLatest": "Ir para o mais recente",
  "sidebar.otherChats": "Outros",
  "trial.have": "Tem um código?",
  "trial.title": "Código de teste",
  "trial.placeholder": "Digite seu código de teste",
  "trial.submit": "Resgatar",
  "trial.checking": "Verificando…",
  "trial.invalid": "Esse código não é válido. Confira e tente de novo.",
  "trial.error": "Não foi possível verificar esse código. Tente de novo.",
  "trial.success": "Teste do Pro ativado. Você tem 75 perguntas e 10 mensagens com arquivo por mês até {date}.",
  "trial.active": "Teste Pro até {date}",
  "sidebar.planTrial": "Teste do {plan}",
  "sidebar.managePlan": "Gerir plano",
  "trial.ends": "O período de teste termina a {date}",
  "pe.consent": "Concordo que os dados da minha solicitação sejam compartilhados com a AquaNetica e com os fornecedores contatados em meu nome, e concordo com os {terms} e com a {privacy}.",
  "pe.consentTerms": "Termos de Serviço",
  "pe.consentPrivacy": "Política de Privacidade",
};

export default strings;
